import type { CaseItem } from '@/lib/caseTypes';

type Props = {
  statements: CaseItem['statements'];
};

const StatementList = ({ statements }: Props) => (
  <div className="mt-6 grid grid-cols-1 gap-4 md:grid-cols-2">
    {statements.map((s) => (
      <blockquote key={`${s.who}-${s.role}`} className="flex flex-col rounded-lg border border-background-300/70 bg-background-50 p-5">
        <i className="ri-double-quotes-l text-xl text-accent-500" aria-hidden="true" />
        <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-700">{s.text}</p>
        <footer className="mt-4 flex items-center gap-3 border-t border-background-200 pt-3">
          <span className="flex h-9 w-9 flex-none items-center justify-center rounded-full bg-secondary-100 text-secondary-700">
            <i className="ri-user-3-line" aria-hidden="true" />
          </span>
          <span>
            <span className="block text-sm font-medium text-foreground-900">{s.who}</span>
            <span className="block text-xs text-foreground-500">{s.role}</span>
          </span>
        </footer>
      </blockquote>
    ))}
  </div>
);

export default StatementList;